/**
 * Formats a file size in bytes to a human-readable string
 * @param bytes - File size in bytes
 * @returns Formatted file size string (e.g., "1.25 MB")
 */ export function formatFileSize(bytes) {
    if (!bytes || bytes === 0) return '';
    const BYTES_PER_UNIT = 1024;
    const SIZE_UNITS = [
        'Bytes',
        'KB',
        'MB',
        'GB'
    ];
    const unitIndex = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_UNIT));
    const formattedSize = (bytes / BYTES_PER_UNIT ** unitIndex).toFixed(2);
    return `${Number.parseFloat(formattedSize)} ${SIZE_UNITS[unitIndex]}`;
}
